import { memo } from 'react'
import PropTypes from 'prop-types'
import c from 'classnames'

import styles from './publicAppLogo.module.scss'

const PublicAppLogo = ({ logo, className }) => {
    if (!logo) {
        return null
    }

    return <img key={logo} src={logo} alt="" className={c(styles.logo, className)} />
};

PublicAppLogo.defaultProps = {
    logo: null,
    className: null,
};

PublicAppLogo.propTypes = {
    logo: PropTypes.string,
    className: PropTypes.string,
};

export default memo(PublicAppLogo);
